import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';

import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import * as _moment from 'moment';
// @ts-ignore
import {default as _rollupMoment} from 'moment';
import {GlobalObjectService} from '../../../../class/global-obj';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';

const moment = _rollupMoment || _moment;


@Component({
    selector: 'noos-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    providers: [
        // The locale would typically be provided on the root module of your application. We do it at
        // the component level here, due to limitations of our example generation script.
        // {provide: MAT_DATE_LOCALE, useValue: 'tr-TR'},

        // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
        // `MatMomentDateModule` in your applications root module. We provide it at the component level
        // here, due to limitations of our example generation script.
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        // {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: {month: 'short', year: 'numeric', day: 'numeric'},
                },
                display: {
                    dateInput: 'DD.MM.YYYY',
                    monthYearLabel: 'DD.MM.YYYY',
                    dateA11yLabel: 'DD.MM.YYYY',
                    monthYearA11yLabel: 'DD.MM.YYYY',
                },
            },
        },
    ],
})
@NoosFormTypeService.register('date')
export class DateComponent implements OnInit, AfterViewInit, FormItemComponentInterface, OnChanges {

    prop: IFormItemsControls;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    dateVal: any;
    isFilter = false;

    locale = 'tr';
    thisAppearance: any = 'outline';
    justShowField = false;

    ngAfterViewInit(): void {

        const setting = GlobalObjectService.getVar('setting');
        if (setting.env.length > 0) {
            this.locale = undefined !== setting.env[0].locale ? setting.env[0].locale.toString() : 'tr';
        } else {
            this.locale = undefined !== this.prop.options.locale ? this.prop.options.locale.toString() : 'tr';
        }
        if (this.locale !== '') {
            this.adapter.setLocale(this.locale);
        }
        if (this.prop.defaultValue !== '') {
            this.dateVal = new Date(this.prop.defaultValue);
            this.prop.defaultValue = this.dateVal.toDateString();
        }

        if (this.prop.discardEditList !== undefined) {
            this.justShowField = this.prop.discardEditList;
            this.prop.requared = this.justShowField ? false : this.prop.requared;
        }

    }

    addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
        const date = new Date(event.value.toString());
        this.prop.defaultValue = date.toDateString();
    }

    ngOnInit(): void {
        if (this.isFilter) {
            this.prop.requared = false;
        }
    }

    constructor(private adapter: DateAdapter<any>) {
    }


    onClear($event: any) {
        event.preventDefault();
        this.dateVal = '';
        this.prop.defaultValue = '';
    }

    ngOnChanges(changes: any): void {
        if (this.prop.defaultValue) {
            this.dateVal = new Date(this.prop.defaultValue);
        }
    }
}
